import React from 'react'

import Icon from '@f/elements/Icon'
import { HouseIcon } from '@f/elements/Icon/HouseIcon'
import { LOCATION_TYPES } from '@js/common/constants'

const OfficeDetailCard = ({ item }) => {
  return (
    <>
      {item.highlight_map ? (
        <span
          className='[ f-fl-expand f-d-flc f-radius-card-large-top f-p-a-020 f-c-ba-pri f-c-fo-whi f-t-left ] OfficeMap-list-item-highlight'
          style={
            item.office_profile_picture
              ? {
                  backgroundImage: `linear-gradient(0deg, rgba(0,0,0,1), rgba(0,0,0,0)), url(${item.office_profile_picture})`
                }
              : {}
          }>
          <span className='[ f-t-tminor f-p-t-050 f-t-ellip ]'>
            {item.vendor_name}
          </span>
          <span className='[ f-t-body f-t-ellip ]'>{item.vendor_slogan}</span>
        </span>
      ) : null}
      <span
        className={`[ f-d-flr ${
          item.highlight_map
            ? 'f-radius-card-large-bottom'
            : 'f-radius-card-large'
        } f-p-a-020 f-c-ba-whi f-t-left ]`}
        style={{ maxWidth: '100%' }}>
        <span className='[ f-fl-none f-d-flr f-fl-jc-ce f-fl-al-ce f-shadow-strong f-m-r-020 ] OfficeMap-list-item-logo-wrap'>
          {item.vendor_logo ? (
            <img
              src={item.vendor_logo}
              className='[ f-fl-none f-m-a-010 ] OfficeMap-list-item-logo'
            />
          ) : (
            <svg
              xmlns='http://www.w3.org/2000/svg'
              x='0px'
              y='0px'
              width='48px'
              height='48px'
              viewBox='0 0 48 48'>
              <g transform='translate(0, 0)'>
                <path
                  d='M41,43V3a1,1,0,0,0-1-1H36a1,1,0,0,0-1,1V43Z'
                  fill='#d8d8d8'></path>
                <path
                  d='M13,43V3a1,1,0,0,0-1-1H8A1,1,0,0,0,7,3V43Z'
                  fill='#d8d8d8'></path>
                <rect x='3' y='43' width='14' height='3' fill='#b3b3b3'></rect>
                <rect x='31' y='43' width='14' height='3' fill='#b3b3b3'></rect>
                <rect x='7' y='26' width='6' height='2' fill='#b3b3b3'></rect>
                <rect x='35' y='26' width='6' height='2' fill='#b3b3b3'></rect>
                <path
                  d='M46,6H2A1,1,0,0,0,1,7V25a1,1,0,0,0,1,1H46a1,1,0,0,0,1-1V7A1,1,0,0,0,46,6Z'
                  fill='#d8d8d8'></path>
                <rect x='3' y='8' width='42' height='16' fill='#fff'></rect>
                <path
                  d='M45,17.036l-9-9h9Zm-25-9h8l16,16H36Zm8,16H20l-16-16h8Zm-25-9,9,9H3Z'
                  fill='#ed7064'></path>
                <path
                  d='M13,6H6.966V3a1,1,0,0,1,1-1H12a1,1,0,0,1,1,1Z'
                  fill='#ffd764'></path>
                <path
                  d='M41,6H34.966V3a1,1,0,0,1,1-1H40a1,1,0,0,1,1,1Z'
                  fill='#ffd764'></path>
              </g>
            </svg>
          )}
        </span>
        <span className='[ f-fl-expand f-d-flc f-fl-jc-ce f-overflow ] OfficeMap-list-item-details'>
          <span className='[ f-t-body f-t-ellip ]'>{item.display_name}</span>
          <span className='[ f-t-body f-t-ellip ]'>{item.address_line_1}</span>
          <span className='[ f-t-body f-t-ellip ]'>
            {item.postal_code} {item.city}
          </span>
        </span>
        {item.highlight_map ? (
          <span className='[ f-hidden:s f-fl-none f-d-flc f-fl-jc-ce f-fl-al-ce f-m-l-020 ] OfficeMap-list-item-type'>
            <span className='[ f-c-ba-bac025 f-bo-round ] OfficeMap-list-item-type-icon'>
              <CardIcon locationType={item.location_type} />
            </span>
            <span className='[ f-t-centre f-t-micro f-p-t-010 ]'>
              {
                LOCATION_TYPES.find(({ name }) => name === item.location_type)
                  .label
              }
            </span>
          </span>
        ) : null}
      </span>
    </>
  )
}

const CardIcon = ({ locationType }) =>
  ({
    house_vendor: (
      <Icon icon='zentrale-64px' className='[ f-icon-030 f-c-st-pri ]' />
    ),
    sales_profile: (
      <Icon icon='sales-agent-16px' className='[ f-icon-030 f-c-st-pri ]' />
    ),
    model_house: <HouseIcon className='[ f-icon-030 f-c-st-pri ]' />
  }[locationType])

export default OfficeDetailCard
